import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import types from '../types';
import { encryptor } from '../encryptor';

const init = {
  token: null,
  admin: null,
  failure: false,
};

const auth = (state = init, { type, payload }) => {
  switch (type) {
    // START
    case types.LOGIN_START:
    case types.LOGOUT_START:
      return state;

    // SUCCESS
    case types.LOGIN_SUCCESS:
      localStorage.setItem("firoz_token",payload.token)

      return {
        ...state,
        token: payload.token,
        admin: payload.user_data,
        failure: false,
      };
    case types.GET_ADMIN_SUCCESS:
      return {
        ...state,
        admin: payload.admin,
        failure: false,
      };
    case types.LOGOUT_SUCCESS:
      return init;

    // FAILURE
    case types.LOGIN_FAILURE:
    case types.LOGOUT_FAILURE:
      return { ...init, failure: true };

    // 2FA
    case types.ENABLE_2FA_FAILURE:
      return { ...state, admin: { ...state.admin, google2fa_enabled: 1 } };
    case types.DISABLE_2FA_SUCCESS:
      return { ...state, admin: { ...state.admin, google2fa_enabled: 0 } };

    default:
      return state;
  }
};

const authConfig = {
  storage,
  key: 'betconix_auth',
  white: ['token'],
  transforms: [encryptor],
};

export default persistReducer(authConfig, auth);
